import { useState, useCallback } from 'react';

import FiltersRequiredManagerContext from './FiltersRequiredManagerContext';

const FiltersRequiredManagerProvider = ({ children }) => {
  const [requiredState, setRequiredState] = useState({});

  const registerRequired = useCallback(
    (filter) => {
      setRequiredState((state) => {
        if (requiredState.hasOwnProperty(filter)) {
          return { ...state, [filter]: state[filter] + 1 };
        }
        return { ...state, [filter]: 1 };
      });
    },
    [setRequiredState]
  );
  const unregisterRequired = useCallback(
    (filter) => {
      setRequiredState(({ [filter]: oldFilter, ...rest }) => {
        if (requiredState[filter] > 1) {
          return { ...rest, [filter]: oldFilter - 1 };
        }
        return { ...rest };
      });
    },
    [setRequiredState]
  );

  return (
    <FiltersRequiredManagerContext.Provider
      value={{
        registerRequired,
        requiredState,
        unregisterRequired,
      }}
    >
      {children}
    </FiltersRequiredManagerContext.Provider>
  );
};

export default FiltersRequiredManagerProvider;
